<template>
  <div class="ren-decoration-cp ren-decoration-cp-blank" :style="{ height: `${height}px` }" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const height = computed(() => Math.max(0, numberValue(props.component.props?.height, 24)))
</script>
